export default __webpack_public_path__ + "static/media/vehicle-1.afa59477.png";